export default __webpack_public_path__ + "static/media/img_about02.54209770.png";